// Collection runs through dues.collect_by_invoice (283); the global variant was never routed.
export const COLLECT_CUSTOMER_GLOBAL_DUES = 283;
export const CUSTOMER_GLOBAL_DUES_INDEX = 1325;
export const OWNER_GLOBAL_DUES_INDEX = 291;
